import { Tag } from '@zillow/constellation';

const TYPE_TO_APPEARANCE = {
  info: 'info',
  neutral: 'gray',
  success: 'success',
  warn: 'warning',
  caution: 'warning',
  in_progress: 'aqua',
} as const;

type Props = {
  message: string;
  type: 'info' | 'neutral' | 'success' | 'warn' | 'in_progress' | 'caution';
  size?: 'sm' | 'md';
};

const ConnectedStatus = ({ message, type, size = 'md' }: Props) => {
  const appearance = TYPE_TO_APPEARANCE[type] || TYPE_TO_APPEARANCE.neutral;

  return (
    <Tag appearance={appearance} data-test="connected-status" size={size} title={message}>
      {message}
    </Tag>
  );
};

export default ConnectedStatus;
